module.exports = __webpack_public_path__ + "img/logo_small.d50d3e13.png";